import React from "react";
import { UpdateShellValidationDTO } from "@/models/interfaces/dtos/update-shell-validation-dto";
import SpaceTypo from "@/models/enums/space-typo.ts";
import ThermicTypo from "@/models/enums/thermic-typo.ts";

export interface PackValidationContextProps {
    modifiedShellTypes: UpdateShellValidationDTO[];

    upsertShellModification: (stringValidationId: string, spaceType: SpaceTypo | undefined, thermalType: ThermicTypo | undefined) => void;
    sendValidations: () => Promise<boolean>;
}

export const PackValidationContext = React.createContext<PackValidationContextProps | undefined>(undefined);